import Main from "../../../../content/notes/weighted-deterministic-aperture/src";
import "../../../../content/notes/weighted-deterministic-aperture/src/index.css";
import * as React from 'react';
export default {
  Main,
  React
};